import { useCallback, useRef } from 'react';
import uuid from 'uuid/v4';
import { AISessionState } from '../events';
export var useAIInstrumentationSetup = function useAIInstrumentationSetup(singleInstrumentationID) {
  var singleInstrumentationIDRef = useRef(undefined);
  var aiSessionStateRef = useRef(AISessionState.unset);
  var setAISessionState = useCallback(function (nextState) {
    aiSessionStateRef.current = nextState;
  }, []);
  var getAISessionState = useCallback(function () {
    return aiSessionStateRef.current;
  }, []);
  var refreshSingleInstrumentationID = useCallback(function (customSingleInstrumentationID) {
    var _ref;
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. default behaviour generates through uuid lib
    singleInstrumentationIDRef.current = (_ref = customSingleInstrumentationID !== null && customSingleInstrumentationID !== void 0 ? customSingleInstrumentationID : singleInstrumentationID) !== null && _ref !== void 0 ? _ref : uuid();
  }, [singleInstrumentationID]);
  var getSingleInstrumentationID = useCallback(function () {
    // this handles a race condition when we have a new singleInstrumentationID from the user config
    // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
    // singleInstrumentationID at first step and then return a new one.
    if (singleInstrumentationID && singleInstrumentationID !== singleInstrumentationIDRef.current) {
      refreshSingleInstrumentationID();
    }
    return singleInstrumentationIDRef.current;
  }, [refreshSingleInstrumentationID, singleInstrumentationID]);
  return {
    refreshSingleInstrumentationID: refreshSingleInstrumentationID,
    getSingleInstrumentationID: getSingleInstrumentationID,
    setAISessionState: setAISessionState,
    getAISessionState: getAISessionState
  };
};